import axiosInstance from 'service/axiosInstance';
import { normalizeApiError } from 'utils/normalizeApiError';

export interface CreateWorkStatusPayload {
  projectUuid: string;
  name: string;
  workStatusCategory?: 'TODO' | 'IN_PROGRESS' | 'DONE' | string;
  workStatusUuid?: string;
  statusOrder?: number;
}

export interface CreateWorkStatusResponse {
  status: boolean;
  message: string;
  ipAddress: string;
  projectUuid: string;
  workStatusUuid: string;
  name: string;
  workStatusCategory: string;
}

export const createWorkStatus = async (
  payload: CreateWorkStatusPayload
): Promise<CreateWorkStatusResponse> => {
  try {
    const { data } = await axiosInstance.post<{ response: CreateWorkStatusResponse }>(
      '/pmo/create-or-update-project-work-status',
      payload
    );

    // Backend returns HTTP 200 even on errors, so check the body explicitly
    if (!data.response?.status) {
      throw new Error(data.response?.message || 'Failed to create column');
    }

    return data.response;
  } catch (error) {
    throw normalizeApiError(error);
  }
};
